import { ReplicantMigrator } from '@play-co/replicant';

// IMPORTANT: Do *NOT* add any other imports. Migrations must stay
// self-contained forever — inline any helper you need.
//
// MIGRATION SAFETY — same rules as src/replicant/migrations/migrator.ts:
// append-only (emergency no-op only for critically broken migrations —
// already-migrated states keep the broken shape and version), no rollback,
// mutate the provided state in place (return value ignored), guard every
// property access, two-step release for field removal/rename/retype, and a
// numbered test file (incl. empty-state {}) for every new migration.
// Details: .claude/rules/replicant.md ("State Migrations").
//
// Rollout: this is a SHARED-state migrator. It does not trigger the player
// AppInitFailed(errorCode = version_error) launch failure, but it is still
// mixed-version sensitive: code that sees a shared-state item at a higher
// version than it knows falls back to containment behavior (e.g. skipping
// message reduction). Ship migrations standalone, roll out as fast as is safe,
// and verify old-new version interactions.

const migrator = new ReplicantMigrator();

/**
 * Remove createdAt
 * Required before upgrading to replicant 30
 */
migrator.addMigration(1, (state) => {
  if ('createdAt' in state) {
    delete state.createdAt;
  }
});

// Add new migrations right above this line. Do *NOT* modify existing migrations.

export default migrator;
